<div class="min-h-screen bg-gray-50">
	<div class="w-full px-4 py-8">
		<div class="max-w-4xl mx-auto">
			<!-- Header -->
			<div class="mb-8">
				<h1 class="text-3xl font-bold text-gray-900 mb-2">Gestion des catégories</h1>
				<p class="text-gray-600">Créez et gérez les catégories et sous-catégories de produits</p>
			</div>

			<!-- Main Card -->
			<div class="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
				<div class="p-8">
					<!-- Add New Category Section -->
					<div class="mb-8 pb-8 border-b border-gray-200">
						<h2 class="text-lg font-semibold text-gray-900 mb-4">Ajouter une catégorie</h2>
						<div class="flex gap-3">
							<input type="text" class="flex-1 h-10 px-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none" placeholder="Nom de la catégorie" [(ngModel)]="newCategoryInput" />
							<button class="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors" (click)="addCategory()">Créer</button>
						</div>
					</div>

					<!-- Categories List -->
					<div>
						<h2 class="text-lg font-semibold text-gray-900 mb-4">Catégories existantes</h2>
						<div class="space-y-3">
							<div *ngFor="let category of categories" class="border border-gray-200 rounded-lg overflow-hidden">
								<!-- Category Header -->
								<div class="flex items-center justify-between bg-gray-50 px-4 py-3 cursor-pointer hover:bg-gray-100">
									<div class="flex items-center gap-2" (click)="toggleCategory(category)">
										<span class="font-medium text-gray-900" *ngIf="editCategory !== category">{{ category }}</span>
										<input *ngIf="editCategory === category" type="text" [(ngModel)]="editCategoryInput" class="h-8 px-2 border border-gray-300 rounded text-sm" />
										<i class="fa" [ngClass]="expandedCategory === category ? 'fa-chevron-up' : 'fa-chevron-down'" style="color: #6b7280;"></i>
									</div>
									<div class="flex items-center gap-2">
										<button *ngIf="editCategory !== category" class="text-blue-600 hover:text-blue-800 px-2 py-1 rounded transition-colors" (click)="startEditCategory(category)"><i class="fa fa-edit"></i></button>
										<button *ngIf="editCategory === category" class="text-green-600 hover:text-green-800 px-2 py-1 rounded transition-colors" (click)="saveEditCategory(category)"><i class="fa fa-check"></i></button>
										<button *ngIf="editCategory === category" class="text-gray-500 hover:text-gray-700 px-2 py-1 rounded transition-colors" (click)="cancelEditCategory()"><i class="fa fa-times"></i></button>
										<button class="text-red-600 hover:text-red-800 px-2 py-1 rounded transition-colors" (click)="confirmDeleteCategory(category)"><i class="fa fa-trash"></i></button>
									</div>
								</div>

								<!-- Sub-categories List -->
								<div *ngIf="expandedCategory === category" class="px-4 py-4 bg-white border-t border-gray-200">
									<div class="mb-4">
										<h3 class="text-sm font-semibold text-gray-700 mb-3">Sous-catégories</h3>
										<div class="space-y-2">
											<div *ngFor="let sub of categorySubCategoriesMap[category]" class="border border-gray-200 rounded bg-blue-50">
												<!-- Sub-category Header -->
												<div class="flex items-center justify-between px-3 py-2 cursor-pointer hover:bg-blue-100" (click)="expandedSubCategory === (category + '|' + sub) ? expandedSubCategory = null : expandedSubCategory = (category + '|' + sub)">
													<div class="flex items-center gap-2 flex-1">
														<span class="text-sm text-gray-700" *ngIf="editSubCategory !== sub">{{ sub }}</span>
														<input *ngIf="editSubCategory === sub" type="text" [(ngModel)]="editSubCategoryInput" class="h-7 px-2 border border-gray-300 rounded text-sm" />
														<i class="fa" [ngClass]="expandedSubCategory === (category + '|' + sub) ? 'fa-chevron-up' : 'fa-chevron-down'" style="color: #6b7280; font-size: 12px;"></i>
													</div>
													<div class="flex items-center gap-2">
														<button *ngIf="editSubCategory !== sub" class="text-blue-600 hover:text-blue-800 px-1 py-0.5 rounded" (click)="startEditSubCategory(sub, category); $event.stopPropagation();"><i class="fa fa-edit"></i></button>
														<button *ngIf="editSubCategory === sub" class="text-green-600 hover:text-green-800 px-1 py-0.5 rounded" (click)="saveEditSubCategory(sub, category); $event.stopPropagation();"><i class="fa fa-check"></i></button>
														<button *ngIf="editSubCategory === sub" class="text-gray-500 hover:text-gray-700 px-1 py-0.5 rounded" (click)="cancelEditSubCategory(); $event.stopPropagation();"><i class="fa fa-times"></i></button>
														<button class="text-red-600 hover:text-red-800 px-1 py-0.5 rounded" (click)="confirmDeleteSubCategory(sub, category); $event.stopPropagation();"><i class="fa fa-trash"></i></button>
													</div>
												</div>

												<!-- Product Families List (nested) -->
												<div *ngIf="expandedSubCategory === (category + '|' + sub)" class="px-4 py-3 bg-white border-t border-gray-200">
													<h4 class="text-xs font-semibold text-gray-600 mb-2 uppercase">Familles de produits</h4>
													<div class="space-y-1 mb-3">
														<div *ngFor="let family of subCategoryProductFamiliesMap[category + '|' + sub]" class="flex items-center justify-between bg-green-50 px-2 py-1.5 rounded text-xs">
															<span class="text-gray-700" *ngIf="editProductFamily !== family">{{ family }}</span>
															<input *ngIf="editProductFamily === family" type="text" [(ngModel)]="editProductFamilyInput" class="h-6 px-2 border border-gray-300 rounded text-xs" />
															<div class="flex items-center gap-1">
																<button *ngIf="editProductFamily !== family" class="text-blue-600 hover:text-blue-800 px-0.5 py-0.25 rounded text-xs" (click)="startEditProductFamily(family, sub, category)"><i class="fa fa-edit"></i></button>
																<button *ngIf="editProductFamily === family" class="text-green-600 hover:text-green-800 px-0.5 py-0.25 rounded text-xs" (click)="saveEditProductFamily(family, sub, category)"><i class="fa fa-check"></i></button>
																<button *ngIf="editProductFamily === family" class="text-gray-500 hover:text-gray-700 px-0.5 py-0.25 rounded text-xs" (click)="cancelEditProductFamily()"><i class="fa fa-times"></i></button>
																<button class="text-red-600 hover:text-red-800 px-0.5 py-0.25 rounded text-xs" (click)="confirmDeleteProductFamily(family, sub, category)"><i class="fa fa-trash"></i></button>
															</div>
														</div>
														<div *ngIf="!subCategoryProductFamiliesMap[category + '|' + sub] || subCategoryProductFamiliesMap[category + '|' + sub].length === 0" class="text-xs text-gray-500 italic">Aucune famille</div>
													</div>
													<!-- Add Product Family Form -->
													<div class="flex gap-2">
														<input type="text" class="flex-1 h-8 px-2 border border-gray-200 rounded text-xs focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none" placeholder="Nouvelle famille" [(ngModel)]="newProductFamilyInput" />
														<button class="px-3 py-1 bg-green-600 hover:bg-green-700 text-white text-xs font-medium rounded transition-colors" (click)="newProductFamilyForCategory = category; newProductFamilyForSubCategory = sub; addProductFamily()">Ajouter</button>
													</div>
												</div>
											</div>
										</div>
									</div>

									<!-- Add Sub-category Form -->
									<div class="flex gap-2 mb-4">
										<input type="text" class="flex-1 h-9 px-3 border border-gray-200 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none" placeholder="Nouvelle sous-catégorie" [(ngModel)]="newSubCategoryInput" />
										<button class="px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded transition-colors" (click)="newSubCategoryForCategory = category; addSubCategory()">Ajouter</button>
									</div>
								</div>
							</div>
						</div>

						<!-- Empty State -->
						<div *ngIf="categories.length === 0" class="text-center py-8">
							<i class="fa fa-inbox text-4xl text-gray-300 mb-3 block"></i>
							<p class="text-gray-500">Aucune catégorie créée. Créez-en une pour commencer.</p>
						</div>

						<!-- Delete Confirmation Dialog (moved to root) -->
<app-confirmation-dialog
	[isVisible]="showDeleteConfirmation"
	[title]="deleteTarget?.type === 'category' ? 'Confirmer la suppression de la catégorie' : (deleteTarget?.type === 'sub-category' ? 'Confirmer la suppression de la sous-catégorie' : 'Confirmer la suppression de la famille de produits')"
	[message]="deleteTarget?.type === 'category' ? 'Êtes-vous sûr de vouloir supprimer cette catégorie ? Cette action est irréversible.' : (deleteTarget?.type === 'sub-category' ? 'Êtes-vous sûr de vouloir supprimer cette sous-catégorie ? Cette action est irréversible.' : 'Êtes-vous sûr de vouloir supprimer cette famille de produits ? Cette action est irréversible.')"
	[confirmText]="'Supprimer'"
	[cancelText]="'Annuler'"
	[type]="'danger'"
	(confirm)="onDeleteConfirm()"
	(cancel)="onDeleteCancel()"
	(close)="onDeleteCancel()">
</app-confirmation-dialog>

						<!-- Feedback Snackbar/Alert Placeholder -->
						<div *ngIf="feedbackMessage" class="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-50">
							{{ feedbackMessage }}
						</div>
						<div *ngIf="errorMessage" class="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-lg shadow-lg z-50">
							{{ errorMessage }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
<!-- Removed extra closing div to fix template error -->
